export default {
    values: {
        'View Database': 'Visualizar database',
        'Database Configuration': 'Configurar Database',
        'Delete Database': 'Deletar Database',

        'Last Update': 'Última atualização',
        'Last Update by': 'Última atualização por',
        'Search for a Database':'Buscar database',
        'Success': 'Sucesso!',
        'Data imported!': 'Planilha importada com sucesso!',

        'Perspective': 'Perspectiva',
        'Configuration': 'Configuração',
        'Average in the period': 'Disponibilidade no período',
        'Save': 'Salvar',
        'cancel': 'cancelar',

        'Loading...': 'Carregando...',
        'Importing': 'Importando',

        'Importing spreadsheet data...': 'Importando dados da planilha...',
        'Data is being uploaded': 'Os dados estão sendo enviados',
        'Error importing spreadsheet. Check the file and try again.': 'Erro na importação da planilha. Verifique o arquivo e tente novamente.',

        'Availability': 'Disponibilidade',
        'Requests without errors': 'Requests sem erros',
        'No events in this period': 'Sem eventos no período',

        'Year': 'Ano',
        'Month': 'Mês',
        'Day': 'Dia',
        'Hour': 'Período',
        'Period': 'Período',
        'Sample': 'Amostra',
        'Requests': 'Requisições',
        'Errors': 'Erros',
        'SLA': 'Disponibilidade',
        'Application': 'Aplicação',
        'Back': 'Voltar',

        'Quick navigation': 'Navegação rápida para',
        'this year': 'este ano',
        'this month': 'este mês',
        'today': 'hoje',
        'now': 'agora',

        'SLA this year': 'Disponibilidade este ano',
        'SLA in the year': 'Disponibilidade no ano',
        'SLA this month': 'Disponibilidade este mês',
        'SLA in the month': 'Disponibilidade no mês',
        'SLA today': 'Disponibilidade hoje',
        'SLA in the day': 'Disponibilidade no dia',
        'Choose the': 'Escolha o',

        'January': 'Janeiro',
        'February': 'Fevereiro',
        'March': 'Março',
        'April': 'Abril',
        'May': 'Maio',
        'June': 'Junho',
        'July': 'Julho',
        'August': 'Agosto',
        'September': 'Setembro',
        'October': 'Outubro',
        'November': 'Novembro',
        'December': 'Dezembro',

        'Jan': 'Jan',
        'Feb': 'Fev',
        'Mar': 'Mar',
        'Apr': 'Abr',
        'Jun': 'Jun',
        'Jul': 'Jul',
        'Aug': 'Ago',
        'Sep': 'Set',
        'Oct': 'Out',
        'Nov': 'Nov',
        'Dec': 'Dez'
    }
};
